import {
  SUBMIT_TITLE,
  SUBMIT_TITLE_SUCCESS,
  SUBMIT_TITLE_FAILED,
  CLEAR_TITLE_CHECK_ERROR,
  REMOVE_TITLE_RESPONSE,
  SET_OPEN_SALVAGE_ALERT,
  SET_MOVE_TO_NEXT_TAB,
  CLEAR_TITLE_RESPONSE,
  DOWNLOAD_TITLE_OUTPUT,
  DOWNLOAD_TITLE_OUTPUT_SUCCESS,
  DOWNLOAD_TITLE_OUTPUT_FAILED,
} from './types';

const INITIAL_STATE = {
  titleCheckResponse: {},
  error: null,
  Slavage: false,
  isLoading: false,
  pdfLoading: false,
};

const titleCheckReducer = (state = INITIAL_STATE, action) => {
  const { type, payload } = action;
  switch (type) {
    case SUBMIT_TITLE:
      return {
        ...state,
        isLoading: true,
        error: null,
      };

    case SUBMIT_TITLE_SUCCESS:
      return {
        ...state,
        titleCheckResponse: payload,
        isLoading: false,
        error: null,
      };

    case SUBMIT_TITLE_FAILED:
      return {
        ...state,
        error: payload || "Unexpected error Occurred, Try Again",
        isLoading: false,
      };

    case CLEAR_TITLE_CHECK_ERROR:
      return {
        ...state,
        error: null,
        isLoading: false,
      };

    case REMOVE_TITLE_RESPONSE:
      return {
        ...state,
        titleCheckResponse: null,
      }

    case SET_OPEN_SALVAGE_ALERT:
      return {
        ...state,
        openSalvageAlert: payload,
      }

    case SET_MOVE_TO_NEXT_TAB:
      return {
        ...state,
        moveToNextTab: payload,
      }

    case CLEAR_TITLE_RESPONSE:
      return {
         ...state,
         titleCheckResponse: {},
      }

    case DOWNLOAD_TITLE_OUTPUT:
      return {
        ...state,
        pdfLoading: true,
      }

    case DOWNLOAD_TITLE_OUTPUT_SUCCESS:
      return {
        ...state,
        pdfLoading: false,
      }

    case DOWNLOAD_TITLE_OUTPUT_FAILED:
      return {
        ...state,
        pdfLoading: false,
      }

    default:
      return state;
  }
};

export default titleCheckReducer;
